import React, { Dispatch, ReactNode, SetStateAction } from "react";

import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalTitle,
  OutsideClickModes,
} from "src/app/components/Modal/Modal";
import ProjectsSearchSelector from "src/app/dropdowns/ProjectsSearchSelector/ProjectsSearchSelector";
import { translateMessage } from "src/app/methods/translateMessage";
import { ImageOption } from "src/app/components/CustomSelect/CustomSelect";
import { ReactComponent as PlusIcon } from "src/images/plus-alt.svg";
import { WorkspacePermissionsEnum } from "src/utils/PermissionsEnums";
import { RootState } from "src/redux/reducers";
import { SelectOption } from "../CreateNewProjectPane/types";

import "./SelectCampaignModal.scss";

interface Props {
  onClose: () => void;
  confirm: {
    action: (projectUuid: string) => void;
    text: ReactNode | string;
  };
  selectedCampaign: SelectOption | null;
  setSelectedCampaign: Dispatch<SetStateAction<SelectOption | null>>;
  openCreateNewProjectModal?: () => void;
}

export const SelectCampaignModal = (props: Props) => {
  const {
    onClose,
    selectedCampaign,
    setSelectedCampaign,
    confirm,
    openCreateNewProjectModal,
  } = props;

  const intl = useIntl();

  const { identity } = useSelector((state: RootState) => state.mainReducer);

  const handleClose = () => {
    setSelectedCampaign(null);
    onClose();
  };

  const handleConfirm = () => {
    if (selectedCampaign) {
      confirm.action(selectedCampaign.value);
      handleClose();
    }
  };

  return (
    <Modal
      className="select-campaign-modal"
      overlayClassName="select-campaign-modal__overlay"
      onClose={handleClose}
      displayCancelButton
      onConfirmClick={handleConfirm}
      confirmButtonText={confirm.text}
      confirmButtonDisabled={!selectedCampaign?.value}
      outsideClick={OutsideClickModes.Allow}
    >
      <ModalTitle>
        <IDHFormattedMessage
          id="ws_select_campaign"
          defaultMessage="Select campaign"
        />
      </ModalTitle>

      <ProjectsSearchSelector
        id="projectUuid"
        value={selectedCampaign}
        handleChange={setSelectedCampaign}
        afterMenuList={
          openCreateNewProjectModal &&
          identity.permissions?.workspace.includes(
            WorkspacePermissionsEnum.CREATE_PROJECTS,
          ) ? (
            <div
              className="create-project-wrap"
              onClick={openCreateNewProjectModal}
            >
              <ImageOption icon={PlusIcon} className="create-project">
                <IDHFormattedMessage
                  id="ws_create_new_campaign"
                  defaultMessage="Create new campaign"
                />
              </ImageOption>
            </div>
          ) : null
        }
        placeholder={translateMessage({
          intl,
          id: "ws_select_campaign",
          defaultMessage: "Select Campaign",
        })}
      />
    </Modal>
  );
};
